import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatNumber(number) {
  if (number == null || isNaN(number)) return "0";
  return Math.round(n).toLocaleString("id-ID");
}

const MONTH_NAMES = ["Jan", "Feb", "Mar", "Apr", "Mei", "Jun", "Jul", "Ags", "Sep", "Okt", "Nov", "Des"];

/** Bulan berjalan (UTC) dalam format "YYYY-MM". */
export function currentMonth() {
  return new Date().toISOString().slice(0, 7);
}

/** "2026-08" → "Agu 2026" */
export function monthLabel(m) {
  const [y, mm] = String(m || "").split("-").map((v) => parseInt(v, 10));
  if (!y || isNaN(mm) || mm < 1 || mm > 12) return m || "";
  return `${MONTH_NAMES[mm - 1]} ${y}`;
}

/** "2026-08" → "Jul 2026"; "2026-01" → "Des 2025" */
export function prevMonthLabel(m) {
  return monthLabel(shiftMonth(m, -1));
}

/** shiftMonth("2026-08", -1) → "2026-07"; shiftMonth("2026-12", 1) → "2027-01" */
export function shiftMonth(m, delta) {
  const [y, mm] = String(m || "").split("-").map((v) => parseInt(v, 10));
  const total = y * 12 + (mm - 1) + delta;
  const nY = Math.floor(total / 12);
  const nM = (total % 12) + 1;
  return `${nY.toString().padStart(4, "0")}-${nM.toString().padStart(2, "0")}`;
}